import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { workSchedulesService } from '../api/workSchedules.service';
import { WORK_SCHEDULES_KEYS } from './queryKeys';
import type { UpsertMemberWorkSchedulePayload } from '../types';

interface UpsertMemberArgs {
  userId: string;
  payload: UpsertMemberWorkSchedulePayload;
}

/**
 * Creates or updates a member's work schedule override.
 * On success, invalidates that member's query and the overrides list.
 */
export function useUpsertMemberWorkSchedule() {
  const queryClient = useQueryClient();
  const orgId = useOrganizationStore((s) => s.activeOrganizationId)!;

  return useMutation({
    mutationFn: ({ userId, payload }: UpsertMemberArgs) =>
      workSchedulesService.upsertMember(userId, payload),
    onSuccess: (_data, { userId }) => {
      queryClient.invalidateQueries({ queryKey: WORK_SCHEDULES_KEYS.member(orgId, userId) });
      queryClient.invalidateQueries({ queryKey: WORK_SCHEDULES_KEYS.members(orgId) });
    },
  });
}
